import { Component, Input, OnInit, TemplateRef, ViewChild,Output,EventEmitter } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SubscriptService } from '../../service/header.service';
import { DatePipe } from '@angular/common'
import { HttpClient } from '@angular/common/http';
import {  NbDialogService } from '@nebular/theme';
import { CurrencyPipe} from '@angular/common';
import * as _ from 'lodash';
import { Router } from '@angular/router';

@Component({
  selector: 'app-info-EOS-ord',
  templateUrl: './info-EOS-ord.component.html',
  styleUrls: ['./info-EOS-ord.component.scss']
})
export class InfoEOSOrdComponent implements OnInit {

  @Output() emitList = new EventEmitter();
  @Output() emitClose = new EventEmitter();
  @Input() info: {
    moType: number; //目前編輯狀態 4.查看
    orgType: number; //1.訂單紀錄 2.發票紀錄   
    eosNo:string;
  };

  @ViewChild("Modal") Modal: TemplateRef<any>;
  modalRef = null; //談窗鉤子


  //基本資料
  USR_AccountInfo_ID: string;
  USR_EmployeeInfo_ID: string;
  ORG_Company_ID: number;
  ORG_Store_ID: number;
  authChangeSub:any;

  orderDetail:any;


  constructor(
    private dialogService: NbDialogService,
    private http: HttpClient,
    private cookieService: CookieService,
    private router: Router
  ) {
    this.USR_AccountInfo_ID = this.cookieService.get('USR_AccountInfo_ID') ? 
      "USR_AccountInfo_ID_"+this.cookieService.get('USR_AccountInfo_ID') :
        this.cookieService.get('USR_POSEmployeeInfo_ID') ?  
          "USR_POSEmployeeInfo_ID"+this.cookieService.get('USR_POSEmployeeInfo_ID') : null;
    this.USR_EmployeeInfo_ID = this.cookieService.get('USR_EmployeeInfo_ID')
    this.ORG_Company_ID = parseInt(this.cookieService.get('ORG_Company_ID'))
    let cookie_sid = this.cookieService.get('ORG_Store_ID')
    this.ORG_Store_ID= (cookie_sid && cookie_sid!='') ? parseInt(cookie_sid) : null

  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.onOpen(this.info)

  }


  onOpen(info){
    this.getOrderDetail(info.eosNo) 


    this.modalRef = this.dialogService.open(this.Modal, {});
    this.modalRef.onClose.subscribe(result => {
      this.emitClose.emit(true);
    });
  }
  


  
  //取得詳細資料
  getOrderDetail(ordno) {

    this.http.get<any>('api/EOS/OrderManage/GetOrderDetail?EOSNo=' + ordno).subscribe({
      next: data => {
        this.orderDetail = _.assign(data.LIST[0])

        
      },
      error: error => {
        console.error('There was an error!', error);
      }
    });

  }


  onClose(){
    this.modalRef.close()
  }


}
